import { EligibleCandidateAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';
import { IGetEligibleCandidatesPayload, IGetEligibleCandidatesResult } from '../types';

export const getEligibleCandidates = async (
  payload: IGetEligibleCandidatesPayload,
): Promise<IGetEligibleCandidatesResult> => {
  const response = await PermanentJobsApi.getEligibleCandidates(payload);

  return EligibleCandidateAdapters.toGetEligibleCandidatesResult(response);
};
